import type { KatalogKuralPayload } from "@/api/denetim";

/**
 * Denetim kural paneli — gorev A (eski `legacy/denetim.html` kural paneli,
 * `legacy/js/denetim.js:42-55 kuralOku`). Form durumu ile
 * `POST /denetim/katalog/tara` govdesi (`KatalogKuralPayload`) AYNI alan
 * adlarini kullanir, bu yuzden ayri bir "form -> govde" cevirisi gerekmez.
 */
export type DenetimKuralForm = Required<KatalogKuralPayload>;

/** Legacy `denetim.html` input default'lariyla AYNI (bkz. backend
 * app/audit/catalog.py KatalogKurali / DEFAULT_KURAL). */
export const DENETIM_KURAL_VARSAYILAN: DenetimKuralForm = {
  kelime: "pamuk",
  yuzde: 100,
  ozellik_adi: "Kumaş Türü",
  rozet_dosyasi: "pamuk.png",
  kategoriler: [],
  urun_adi_kontrol: true,
  gri_alan: true,
  satisa_kapali_dahil: false,
};

export const DENETIM_KURAL_STORAGE_KEY = "asakai.denetim.kurallar";

function isDenetimKuralForm(value: unknown): value is DenetimKuralForm {
  if (typeof value !== "object" || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.kelime === "string" &&
    typeof v.yuzde === "number" &&
    typeof v.ozellik_adi === "string" &&
    typeof v.rozet_dosyasi === "string" &&
    Array.isArray(v.kategoriler) &&
    v.kategoriler.every((k) => typeof k === "string") &&
    typeof v.urun_adi_kontrol === "boolean" &&
    typeof v.gri_alan === "boolean" &&
    typeof v.satisa_kapali_dahil === "boolean"
  );
}

/**
 * Son kullanılan kural — localStorage'dan okunur (`asakai.denetim.kurallar`,
 * görev talimatı). Kayıt yok/bozuksa ya da localStorage erişilemezse (gizli
 * mod/izin — bkz. Kullanicilar.tsx panoya erişimle aynı desen) sessizce
 * varsayılana düşer.
 */
export function loadDenetimKural(): DenetimKuralForm {
  try {
    const raw = window.localStorage.getItem(DENETIM_KURAL_STORAGE_KEY);
    if (!raw) return DENETIM_KURAL_VARSAYILAN;
    const parsed: unknown = JSON.parse(raw);
    return isDenetimKuralForm(parsed) ? parsed : DENETIM_KURAL_VARSAYILAN;
  } catch {
    return DENETIM_KURAL_VARSAYILAN;
  }
}

export function saveDenetimKural(form: DenetimKuralForm): void {
  try {
    window.localStorage.setItem(DENETIM_KURAL_STORAGE_KEY, JSON.stringify(form));
  } catch {
    // localStorage erisilemezse (gizli mod/izin) sessizce yut — form yine de calisir.
  }
}
